module.exports = __webpack_public_path__ + "img/account-circle.286c1cf0.svg";